import React from 'react';
import { useElementHeight } from '@/hooks/use-element-height';

interface MeasureWrapperProps {
    id: string;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export function MeasureWrapper({ id, children, className, style }: MeasureWrapperProps) {
    const ref = useElementHeight(id);

    return (
        <div ref={ref} className={className} style={style} data-measured-id={id}>
            {children}
        </div>
    );
}
